const autoNgTemplateLoaderTemplate1 = require('./createConfigMap.html');

angular.module('portainer.kubernetes').component('kubernetesCreateConfigMapView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesCreateConfigMapController',
  controllerAs: 'ctrl',
});
